(ns ycweb.app.website.school.course.list
  (:require
   [rum.core :as rum]
   [ycweb.app.website.school.common :as school.common]
   [ycweb.app.website.website :as website]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]))

(rum/defc my-courses < rum/reactive [app-atom]
  (let [state-atom (cmn/action-cursor app-atom)
        courses (cmn/curact state-atom [:courses])]
    [:main
     {:id "main-content" :class (u/bem :yc-page-content [:standard])}
     (headings/heading "My Courses"
       {:type :h1
        :size :large
        :center true})
     [:div
      {:class (u/bem :yc-section [:standard])}
      [:div.flex-grid-group
       (map
         (fn [course]
           (school.common/school-card app-atom course))
         courses)]
      (toaster/loading-overlay app-atom :web.cooking-school/my-courses)]]))

(defmethod flow/render-screen :web.cooking-school/my-courses [app-atom _]
  (website/screen-wrapper app-atom
    (my-courses app-atom)
    {:pagetype :school}))

(defmethod t/transition-open :web.cooking-school/my-courses [app-atom _ _]
  (toaster/open-overlay app-atom :web.cooking-school/my-courses)
  (comms/ajax-get :web.cooking-school/my-courses {}))

(defmethod comms/receive :web.cooking-school/my-courses [app-atom e]
  (toaster/close-overlay app-atom :web.cooking-school/my-courses)
  (swap!
    (cmn/action-cursor app-atom) assoc
    :courses (:courses e)))
